// extracted by mini-css-extract-plugin
export default {"container":"staggered-product-tabs__container___fcp8V","tooltip":"staggered-product-tabs__tooltip___106IN"};